import { c as _c } from "react/compiler-runtime";
import type { PostDetails } from "@/types/posts";
import { CardGrid } from "@/ui/post-cards/card-grid";
export function PostCards(t0) {
  const $ = _c(3);
  const {
    posts
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="theme-transition container my-6 flex items-center gap-y-2 text-2xl text-current lg:px-8"><a className="appearance-none text-left" id="posts">Posts</a></h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== posts) {
    t2 = <div className="mx-auto max-w-screen px-0 pb-8">{t1}<CardGrid posts={posts} /></div>;
    $[1] = posts;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}

/**
 *         <GentleText
          content="Posts"
          textClassName="appearance-none text-left"
          maxWidth="600px"
          as="a"
          textId="posts"
          animateOnlyInView={true}
          inViewThreshold={0.8}
          animationOptions={{ repeat: 0 }}
        />
 */